module.exports = __webpack_public_path__ + "img/Contract Works_Selected.af5e3927.svg";